<ng-container [ngSwitch]="navAction">
    <div *ngSwitchCase="NavOverFlowWrapperAction.NAV_OVERFLOW_MENU">
        <zci-action-nav-overflow-menu [navOverflowMenuConfig]="navOverflowExtendedData">
        </zci-action-nav-overflow-menu>
    </div>
    <div *ngSwitchDefault>
        <span class="visually-hidden">{{ content.global.table?.actions?.noAction }}</span>
    </div>
</ng-container>
